import { render, staticRenderFns } from "./MinuteTypeEditPage.vue?vue&type=template&id=4f585590&scoped=true&"
import script from "./MinuteTypeEditPage.vue?vue&type=script&lang=ts&"
export * from "./MinuteTypeEditPage.vue?vue&type=script&lang=ts&"
import style0 from "./MinuteTypeEditPage.vue?vue&type=style&index=0&id=4f585590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f585590",
  null
  
)

export default component.exports